import './actions-bottom-sheet/actions-bottom-sheet.component';
import './actions-bottom-sheet/actions-bottom-sheet.scss';

import './bringoz-countdown-service-adapter/bringoz-countdown-service-adapter.component';
import './bringoz-countdown-service-adapter/bringoz-countdown-service-adapter.scss';

import './bringoz-service-attachments/bringoz-service-attachments.component';
import './bringoz-service-attachments/bringoz-service-attachments.scss';

import './create-delivery-button/create-delivery-button.component';
import './create-delivery-button/create-delivery-button.scss';

import './deliveries-action-bottom-sheet/deliveries-action-bottom-sheet.component';
import './deliveries-action-bottom-sheet/deliveries-action-bottom-sheet.scss';

import './deliveries-action-footer/deliveries-action-footer.component';
import './deliveries-action-footer/deliveries-action-footer.scss';

import './deliveries-action-menu/deliveries-action-menu.component';
import './deliveries-action-menu/deliveries-action-menu.scss';

import './deliveries-drag-table/deliveries-drag-table.component';
import './deliveries-drag-table/deliveries-drag-table.scss';

import './deliveries-drag-table-row/deliveries-drag-table-row.component';
import './deliveries-drag-table-row/deliveries-drag-table-row.scss';

import './deliveries-group-select/deliveries-group-select.component';
import './deliveries-group-select/deliveries-group-select.scss';

import './deliveries-group-selector/deliveries-group-selector.component';
import './deliveries-group-selector/deliveries-group-selector.scss';

import './deliveries-map-view/deliveries-map-view.component';
import './deliveries-map-view/deliveries-map-view.scss';

import './deliveries-map-view-agents-side-bar/deliveries-map-view-agents-side-bar.component';
import './deliveries-map-view-agents-side-bar/deliveries-map-view-agents-side-bar.scss';

import './deliveries-map-view-routes-side-bar/deliveries-map-view-routes-side-bar.component';
import './deliveries-map-view-routes-side-bar/deliveries-map-view-routes-side-bar.scss';

import './deliveries-map-view-table/deliveries-map-view-table.component';
import './deliveries-map-view-table/deliveries-map-view-table.scss';

import './deliveries-map-view-table-row/deliveries-map-view-table-row.component';
import './deliveries-map-view-table-row/deliveries-map-view-table-row.scss';

import './deliveries-settings-panel/deliveries-settings-panel.component';
import './deliveries-settings-panel/deliveries-settings-panel.scss';

import './deliveries-table/deliveries-table.component';
import './deliveries-table/deliveries-table.scss';

import './deliveries-table-item/deliveries-table-item.component';
import './deliveries-table-item/deliveries-table-item.scss';

import './deliveries-table-row/deliveries-table-row.component';
import './deliveries-table-row/deliveries-table-row.scss';

import './deliveries-table-subset/deliveries-table-subset.component';
import './deliveries-table-subset/deliveries-table-subset.scss';

import './deliveries-table-subset-row/deliveries-table-subset-row.component';
import './deliveries-table-subset-row/deliveries-table-subset-row.scss';

import './deliveries-table-view/deliveries-table-view.component';

import './deliveries-totals-indication/deliveries-totals-indication.component';
import './deliveries-totals-indication/deliveries-totals-indication.scss';

import './deliveries-validation-table/deliveries-validation-table.component';
import './deliveries-validation-table/deliveries-validation-table.scss';

import './deliveries-validation-table-row/deliveries-validation-table-row.component';
import './deliveries-validation-table-row/deliveries-validation-table-row.scss';

import './deliveries-view/deliveries-view.component';
import './deliveries-view/deliveries-view.scss';

import './delivery-agent-comment-indication/delivery-agent-comment-indication.component';
import './delivery-agent-comment-indication/delivery-agent-comment-indication.scss';

import './delivery-detail-panel/delivery-detail-panel.component';
import './delivery-detail-panel/delivery-detail-panel.scss';

import './delivery-detailed-view/delivery-detailed-view.component';
import './delivery-detailed-view/delivery-detailed-view.scss';

import './delivery-detailed-view-pricing/delivery-detailed-view-pricing.component';
import './delivery-detailed-view-pricing/delivery-detailed-view-pricing.scss';

import './service-details-info/service-details-info.component';
import './service-details-info/service-details-info.scss';

import './delivery-edit-view/delivery-edit-view.component';
import './delivery-edit-view/delivery-edit-view.scss';

import './delivery-edit-view-state/delivery-edit-view-state.component';
import './delivery-edit-view-state/delivery-edit-view-state.scss';

import './delivery-history-table/delivery-history-table.component';
import './delivery-history-table/delivery-history-table.scss';

import './delivery-info-button/delivery-info-button.component';
import './delivery-info-button/delivery-info-button.scss';

import './service-info-card/service-info-card.component';
import './service-info-card/service-info-card.scss';

import './delivery-link/delivery-link.component';
import './delivery-link/delivery-link.scss';

import './delivery-package-volume/delivery-package-volume.component';

import './delivery-package-weight/delivery-package-weight.component';

import './delivery-packages-info/delivery-packages-info.component'
import './delivery-packages-info/delivery-packages-info.scss';

import './delivery-packed-indication/delivery-packed-indication.component';
import './delivery-packed-indication/delivery-packed-indication.scss';

import './delivery-routed-indication/delivery-routed-indication.component';
import './delivery-routed-indication/delivery-routed-indication.scss';

import './delivery-spots-indication/delivery-spots-indication.component';
import './delivery-spots-indication/delivery-spots-indication.scss';

import './edit-deliveries-time-window/edit-deliveries-time-window.component'
import './edit-deliveries-time-window/edit-deliveries-time-window.scss'

import './import-recurring-services-table/import-recurring-services-table.component';
import './import-recurring-services-table/import-recurring-services-table.scss';

import './import-recurring-services-table-row/import-recurring-services-table-row.component';
import './import-recurring-services-table-row/import-recurring-services-table-row.scss';

import './import-recurring-services-view/import-recurring-services-view.component';
import './import-recurring-services-view/import-recurring-services-view.scss';

import './operation-detail-panel/operation-detail-panel.component';
import './operation-detail-panel/operation-detail-panel.scss';

import './operation-detailed-view/operation-detailed-view.component';
import './operation-detailed-view/operation-detailed-view.scss';

import './operation-link/operation-link.component';
import './operation-link/operation-link.scss';

import './packing-statuses-display-list/packing-statuses-display-list.component';
import './packing-statuses-display-list/packing-statuses-display-list.scss';

import './packing-statuses-multi-select-list/packing-statuses-multi-select-list.component';
import './packing-statuses-multi-select-list/packing-statuses-multi-select-list.scss';

import './pods-indicator/pods-indicator.component';
import './pods-indicator/pods-indicator.scss';

import './recurring-service-select/recurring-service-select.component';
import './recurring-service-select/recurring-service-select.scss';

import './recurring-service-select-item/recurring-service-select-item.component';
import './recurring-service-select-item/recurring-service-select-item.scss';

import './recurring-service-select-list/recurring-service-select-list.component';
import './recurring-service-select-list/recurring-service-select-list.scss';

import './recurring-services-table/recurring-services-table.component';
import './recurring-services-table/recurring-services-table.scss';

import './recurring-services-table-row/recurring-services-table-row.component';
import './recurring-services-table-row/recurring-services-table-row.scss';

import './recurring-services-view/recurring-services-view.component';
import './recurring-services-view/recurring-services-view.scss';

import './relations-indicator/relations-indicator.component';
import './relations-indicator/relations-indicator.scss';

import './relations-sub-table/relations-sub-table.component';
import './relations-sub-table/relations-sub-table.scss';

import './relations-sub-table-card-row/relations-sub-table-card-row.component';
import './relations-sub-table-card-row/relations-sub-table-card-row.scss';

import './risk-types-display-list/risk-types-display-list.component';
import './risk-types-display-list/risk-types-display-list.scss';

import './service-send-to-market-dialog/service-send-to-market-dialog.component';

import './service-action-menu/service-action-menu.component';
import './service-action-menu/service-action-menu.scss';

import './service-chat-button/service-chat-button.component';
import './service-chat-button/service-chat-button.scss';

import './service-link/service-link.component';
import './service-link/service-link.scss';

import './service-list-item/service-list-item.component';
import './service-list-item/service-list-item.scss';

import './service-map/service-map.component';
import './service-map/service-map.scss';

import './service-missing-items-dialog-view/service-missing-items-dialog-view.component';
import './service-missing-items-dialog-view/service-missing-items-dialog-view.scss';

import './service-missing-item-table/service-missing-item-table.component';
import './service-missing-item-table/service-missing-item-table.scss';

import './service-missing-item-table-row/service-missing-item-table-row.component';
import './service-missing-item-table-row/service-missing-item-table-row.scss';

import './service-operational-contacts-dialog-view/service-operational-contacts-dialog-view.component';
import './service-operational-contacts-dialog-view/service-operational-contacts-dialog-view.scss';

import './service-operational-contacts-table/service-operational-contacts-table.component';
import './service-operational-contacts-table/service-operational-contacts-table.scss';

import './service-operational-contacts-table-row/service-operational-contacts-table-row.component';
import './service-operational-contacts-table-row/service-operational-contacts-table-row.scss';

import './service-offline-actions-view/service-offline-actions-view.component';
import './service-offline-actions-view/service-offline-actions-view.scss';

import './service-price-pop-up/service-price-pop-up.component';
import './service-price-pop-up/service-price-pop-up.scss';

import './service-pricing/service-pricing.component';

import './services-print-page/services-print-page.component';
import './services-print-page/services-print-page.scss';

import './service-progress-bar/service-progress-bar.component';
import './service-progress-bar/service-progress-bar.scss';

import './service-progress-tooltip/service-progress-tooltip.component';
import './service-progress-tooltip/service-progress-tooltip.scss';

import './service-relation-expand-button/service-relation-expand-button.component';
import './service-relation-expand-button/service-relation-expand-button.scss';

import './service-relation-task-item/service-relation-task-item.component';
import './service-relation-task-item/service-relation-task-item.scss';

import './service-relations-table/service-relations-table.component';

import './service-risk-types-multi-select/service-risk-types-multi-select.component'
import './service-risk-types-multi-select/service-risk-types-multi-select.scss';

import './service-risk-types-multi-select-list/service-risk-types-multi-select-list.component'
import './service-risk-types-multi-select-list/service-risk-types-multi-select-list.scss';

import './service-select/service-select.component'
import './service-select/service-select.scss'

import './service-select-list/service-select-list.component'
import './service-select-list/service-select-list.scss'

import './service-send-to-market-dialog/service-send-to-market-dialog.component'

import './service-service-areas-indication/service-service-areas-indication.component';
import './service-service-areas-indication/service-service-areas-indication.scss';

import './service-statues-multi-select/service-statues-multi-select.component';
import './service-statues-multi-select/service-statues-multi-select.scss';

import './service-status-multiple-select-list/service-status-multiple-select-list.component';
import './service-status-multiple-select-list/service-status-multiple-select-list.scss';

import './service-status-select/service-status-select.component';
import './service-status-select/service-status-select.scss';

import './service-sub-tasks-form/service-sub-tasks-form.component';
import './service-sub-tasks-form/service-sub-tasks-form.scss';

import './service-timeline-logs-view/service-timeline-logs-view.component';
import './service-timeline-logs-view/service-timeline-logs-view.scss'

import './service-type-indication/service-type-indication.component';
import './service-type-indication/service-type-indication.scss';

import './service-type-multiple-select/service-type-multiple-select.component';
import './service-type-multiple-select/service-type-multiple-select.scss';

import './service-type-multiple-select-section/service-type-multiple-select-section.component';
import './service-type-multiple-select-section/service-type-multiple-select-section.scss';

import './types-display-list/types-display-list.component';
import './types-display-list/types-display-list.scss';

import './service-view/service-view.component';
import './service-view/service-view.scss';

import './services-action-bar/services-action-bar.component';
import './services-action-bar/services-action-bar.scss';

import './services-assign-agent-dialog-view/services-assign-agent-dialog-view.component';
import './services-assign-agent-dialog-view/services-assign-agent-dialog-view.scss';

import './services-assign-agent-settings-panel/services-assign-agent-settings-panel.component';
import './services-assign-agent-settings-panel/services-assign-agent-settings-panel.scss';

import './services-assign-resource-allocation-dialog-view/services-assign-resource-allocation-dialog-view.component'
import './services-assign-resource-allocation-dialog-view/services-assign-resource-allocation-dialog-view.html'

import './services-assign-resource-allocation-settings-panel/services-assign-resource-allocation-settings-panel.component'
import './services-assign-resource-allocation-settings-panel/services-assign-resource-allocation-settings-panel.scss';

import './services-assign-resource-allocation-table/services-assign-resource-allocation-table.component'
import './services-assign-resource-allocation-table/services-assign-resource-allocation-table.scss'

import './services-assign-resource-allocation-table-row/services-assign-resource-allocation-table-row.component'
import './services-assign-resource-allocation-table-row/services-assign-resource-allocation-table-row.scss'

import './services-assign-route-dialog-view/services-assign-route-dialog-view.component';
import './services-assign-route-dialog-view/services-assign-route-dialog-view.scss';

import './services-assign-route-table/services-assign-route-table.component';
import './services-assign-route-table/services-assign-route-table.scss';

import './services-assign-route-table-row/services-assign-route-table-row.component';
import './services-assign-route-table-row/services-assign-route-table-row.scss';

import './services-assign-route-table-item/services-assign-route-table-item.component';
import './services-assign-route-table-item/services-assign-route-table-item.scss';

import './services-auto-assign-related-services-dialog-view/services-auto-assign-related-services-dialog-view.component';
import './services-auto-assign-related-services-dialog-view/services-auto-assign-related-services-dialog-view.scss';

import './services-edit-bulk-relations-dialog-view/services-edit-bulk-relations-dialog-view.component';
import './services-edit-bulk-relations-dialog-view/services-edit-bulk-relations-dialog-view.scss';

import './services-reset-services-dialog-view/services-reset-services-dialog-view.component';
import './services-reset-services-dialog-view/services-reset-services-dialog-view.scss';

import './services-assign-route-settings-panel/services-assign-route-settings-panel.component';
import './services-assign-route-settings-panel/services-assign-route-settings-panel.scss';

import './services-totals/services-totals.component';
import './services-totals/services-totals.scss';

import './sub-task-actions-table/sub-task-actions-table.component';
import './sub-task-actions-table/sub-task-actions-table.scss';

import './sub-task-actions-table-row/sub-task-actions-table-row.component';
import './sub-task-actions-table-row/sub-task-actions-table-row.scss';

import './upload-deliveries-view/upload-deliveries-view.component';
import './upload-deliveries-view/upload-deliveries-view.scss';

import './delivery-linked-services/delivery-linked-services.component';
import './delivery-linked-services/delivery-linked-services.scss';

import './deliveries-sms-messages-view/deliveries-sms-messages-view.component';
import './deliveries-sms-messages-view/deliveries-sms-messages-view.scss';

import './service-print-page/service-print-page.component';
import './service-print-page/service-print-page.scss';

import './services-location-bulk-edit/services-location-bulk-edit.component';
import './services-location-bulk-edit/services-location-bulk-edit.scss';

import './services-panel/services-panel.component';
import './services-panel/services-panel.scss';

import './service-task-spec-form/service-task-spec-form.component';
import './service-task-spec-form/service-task-spec-form.scss';

import './multi-assign-agent-dialog-view/multi-assign-agent-dialog-view.component';
import './multi-assign-agent-dialog-view/multi-assign-agent-dialog-view.scss';

import './service-task-pods/service-task-pods.component';
import './service-task-pods/service-task-pods.scss';

import './services-settings-panel/services-settings-panel.component';
import './services-settings-panel/services-settings-panel.scss';

import './services-settings-panel/services-settings-panel-template/services-settings-panel-template.component';
import './services-settings-panel/services-settings-panel-template/services-settings-panel-template.scss';
